import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsEmbeddedWidgetsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-embedded-widgets',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed',
	exact: true,
};
